module.exports = __webpack_public_path__ + "img/coloredLogo_blackText.4c4d0598.png";